<template>
    <section class="hero is-fullheight is-dark is-bold">
        <div class="hero-body grid-container">
            <div class="flex-child has-text-justified">
                <h1 class="title">Afinal, o que é a comunicação não-violenta?</h1><br/>
                <h2 class="subtitle" v-html="mensagem"></h2>
            </div>
            <div class="flex-child" style="min-height: 130px;">
                <router-link to="/" class="button is-dark is-rounded"
                             style="height: 130px; width: 130px; margin-top: 5rem" title="Jogar novamente">
                    <i class="fas fa-undo fa-5x"></i><br>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ExtraScreen',
        data: function () {
            return {
                mensagem: 'A Comunicação não-violenta é um modo de se comunicar levando em consideração as emoções e necessidades das pessoas envolvidas. Nela, você se despe temporariamente de julgamentos, de críticas, e tem uma conexão profunda e empática com outras pessoas. A ideia é que, por trás de toda violência, existe um sentimento, uma necessidade que não está sendo atendida e um pedido que quer sair. Desse modo, ao levar em conta os sentimentos, necessidades e pedidos, conseguimos desarmar a violência e chegar na raiz do problema.\n' +
                    '<br/><br/>No entanto, não é fácil se comunicar não-violentamente. Não é justo ter que se despir dos seus impulsos, da sua raiva. Não é justo ter que ser empático com pessoas que te ofendem, que te agridem, que não se interessam pela sua vida. A sensação é que ela surge para nos tornar mansos e dar para nossos agressores um tratamento que não merecem.\n' +
                    'Apesar de ser difícil, talvez lutar contra o fascismo hoje também seja lutar contra nossos impulsos, seja escolher nossas brigas, ter paciência, não dar munição para que possam nos atacar de volta com ela.\n' +
                    '<br/><br/>A comunicação não-violenta não é a resposta, mas talvez nos ajude a chegar nela.\n'
            }
        }
    }
</script>

<style scoped>

</style>